import React, { useState } from "react";
import { Box, Collapse, Paper, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import parse from "html-react-parser";
import { useGA4React } from "ga-4-react";
import { useDispatch, useSelector } from "react-redux";

function DropdownInfoBlock({
  listOnly,
  title,
  content,
  defaultOpen,
  ...props
}) {
  const [open, setOpen] = useState(defaultOpen);
  const ga4 = useGA4React();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const stepper = useSelector((state) => state.stepper.value);
  const isLightMode = useMediaQuery("(prefers-color-scheme: light)");

  const logEvent = (action, label, category) => {
    ga4.event(action, label, category);
  };

  const handleOpenClose = () => {
    const activeStep = stepper.active;
    if (!open) {
      logEvent(
        "open more details",
        stepper.steps[activeStep].name,
        `Step ${activeStep + 1}`
      );
    }
    setOpen(!open);
  };
  return (
    <>
      <Box
        display="flex"
        flexDirection={"row"}
        alignItems={"center"}
        sx={{ cursor: "pointer" }}
        onClick={() => handleOpenClose()}
        {...props}
      >
        <InfoOutlinedIcon
          color="primary"
          sx={{ mr: "8px", fontSize: "0.8rem" }}
        />
        <Typography color="primary" variant={"p"}>
          {title}
        </Typography>
      </Box>
      {!matches && (
        <Collapse in={open}>
          <Paper
            sx={{
              mt: 1,
              p: 2,
              boxShadow: isLightMode
                ? "3px 3px 6px rgba(0, 0, 0, 0.1), -3px -3px 6px rgba(255, 255, 255, 0.7)"
                : "none",
            }}
          >
            <Typography variant={"p"}>{content && parse(content)}</Typography>
          </Paper>
        </Collapse>
      )}
      {matches && (
        <Dialog
          open={open}
          fullscreen
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle sx={{ mt: 1, p: 2 }} variant="h5">
            {title}
            <IconButton
              aria-label="close"
              onClick={() => setOpen(!open)}
              sx={{
                position: "absolute",
                right: matches ? 0 : 8,
                top: matches ? 0 : 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={listOnly && { pl: 0, mt: -1 }}>
            <Typography variant={"p"}>{content && parse(content)}</Typography>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export default DropdownInfoBlock;
